import script from "./EditGoal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditGoal.vue?vue&type=script&setup=true&lang=js"

import "./EditGoal.vue?vue&type=style&index=0&id=2ddb62e9&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ddb62e9"]])

export default __exports__